import { apolloProvider } from '@/modules/GraphQL';
import { GET_VIDEO_DATA } from '@/graphql/material';
import { bizmatesApi } from '@/utils/bizmatesApi';

import logger from '@/modules/Logger';
import store from '@/store';

export const GetVideoDataService = {
  new: async (params) => {
    logger.info(`[Materials][Video] Fetched video from new GraphQL endpoint`, {
      operation: 'materials:get-video'
    });

    const client = apolloProvider.defaultClient;
    const { data } = await client.query({
      query: GET_VIDEO_DATA,
      fetchPolicy: 'network-only',
      variables: {
        input: {
          student_book_id: params.b,
          lesson_no: params.ln,
          lesson_id: params.li,
          rank_id: params.r
        }
      }
    });

    if (data?.mystage_video.video_url) {
      const { video_type, video_url, video_label, video_subscription_url } = data.mystage_video;
      store.commit('video/setVideoLesson', {
        videoId: video_type ? video_url : parseInt(video_url),
        videoType: video_type,
        videoLabel: video_label,
        videoUrl: video_subscription_url
      });
      store.commit('video/setVideoLog', {
        lesson_status: store.lessonStatus,
        program_id: store.programId,
        rank: params.r,
        lesson: params.ln,
        video_label: video_label,
        video_url: video_subscription_url
      });
      return;
    }
    store.dispatch('video/resetVideoSetting');
  },

  legacy: async (params) => {
    logger.info(`[Materials][Video] Fetched video from legacy endpoint`, {
      operation: 'materials:get-video'
    });

    await bizmatesApi
      .get('materials/video.json', { params }, (response) => {
        if (response.data?.v) {
          store.commit('video/setVideoLesson', {
            videoId: response.data.t ? response.data.v : parseInt(response.data.v),
            videoType: response.data.t,
            videoLabel: response.data.l,
            videoUrl: response.data.u
          });
          store.commit('video/setVideoLog', {
            lesson_status: store.lessonStatus,
            program_id: store.programId,
            rank: params.r,
            lesson: params.ln,
            video_label: response.data.l,
            video_url: response.data.u
          });
        } else {
          store.dispatch('video/resetVideoSetting');
        }
      })
      .catch(() => {
        store.dispatch('video/resetVideoSetting');
      });
  }
};
